var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',{staticClass:"font-size--13 mb-3"},[_vm._v(" 📌 정부 지원 크라우드 펀딩(대출형)사업으로 아래 서류 제출이 필요해요! ")]),_c('div',[_c('p',[_vm._v(" > 소상공인 확인서 발급 ("),_c('a',{attrs:{"target":"_blank","href":"https://sminfo.mss.go.kr"}},[_vm._v("https://sminfo.mss.go.kr")]),_vm._v(") ")]),_c('p',[_vm._v("- 중소기업확인서 발급신청 (착한임대인 세액공제용은 불가)")])])])
}]

export { render, staticRenderFns }